import { useEffect, useState } from 'react'

type ClientOnlyProps = {
  children: React.ReactNode
  fallback?: React.ReactNode
}

const ClientOnly = ({ children, fallback = <div>Loading...</div> }: ClientOnlyProps): JSX.Element | null => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return isClient ? <>{children}</> : <>{fallback}</>
}

export default ClientOnly
